import { type ComponentType, useEffect, useState } from "react";

export function withClientOnly<T extends object>(Component: ComponentType<T>) {
    return function WithClientOnly(props: T) {
        const [mounted, setMounted] = useState(false);

        useEffect(() => {
            setMounted(true);
        }, []);

        if (!mounted) {
            return null;
        }

        return <Component {...props} />;
    };
}
